import React from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { styled } from '@linaria/react';
import differenceInDays from 'date-fns/differenceInDays';
import parseISO from 'date-fns/parseISO';
import { getSearchParameters } from 'modules/sapiSearch/selectors';
import { getSelectedAvailabilityDate } from 'modules/search/selectors';
import { Text } from '@daedalus/atlas/Text';
import FormattedMessageWrapper from '@daedalus/core/src/localization/components/FormattedMessage';
import { getCheckOutDate } from '@daedalus/core/src/searchParams/validateSearchParamDates';
import { dateStringToMiddayDate } from '@daedalus/core/src/utils/date';
const SelectedBannerWrapper = /*#__PURE__*/styled('div')({
  name: "SelectedBannerWrapper",
  class: "s1a4331v",
  propsAsIs: false
});
export const SelectedBanner = React.memo(function TopOffer() {
  const {
    formatDate
  } = useIntl();
  const {
    checkIn,
    checkOut
  } = useSelector(getSearchParameters);
  const selectedAvailabilityDate = useSelector(getSelectedAvailabilityDate);
  const nights = differenceInDays(parseISO(checkOut), parseISO(checkIn));
  const selectedCheckOutDate = getCheckOutDate(selectedAvailabilityDate, nights);
  return <SelectedBannerWrapper>
      <Text variant="labelS">
        <FormattedMessageWrapper id="selectedDates" defaultMessage="Selected: {checkIn} - {checkOut}" values={{
        checkIn: formatDate(dateStringToMiddayDate(selectedAvailabilityDate), {
          day: '2-digit',
          month: 'short',
          weekday: 'short'
        }),
        checkOut: formatDate(selectedCheckOutDate, {
          day: '2-digit',
          month: 'short',
          weekday: 'short'
        })
      }} />
      </Text>
    </SelectedBannerWrapper>;
});

require("./SelectedBanner.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./SelectedBanner.tsx");